<div style="padding: 15px 0px;">
  <!-- Header -->
  <div class="question" [ngClass]="{'header': questionsWithSharedHeader[0].responseType === ResponseTypesEnum.RadioButtonHorizontalWithHeader && questionsWithSharedHeader.length >= 5}">
    <div class="question__content"></div>
    <div class="question__options" >
      <div class="question__options--item" *ngFor="let option of questionsWithSharedHeader[0].answers">
        {{option.content.text}}
      </div>
    </div>
  </div>
  <!-- Questions -->
  <ng-container *ngFor="let question of questionsWithSharedHeader">
    <div class="question">
      <div data-test-id="radioButtonVerticalQuestion" class="question__content" [innerHTML]="question.content.text | replacePatientTerm : question.content.patientTerms : patientTerm! | sanitizeHtml"></div>
      <mat-radio-group class="question__options" aria-labelledby="example-radio-group-label">
        <div class="question__options--item" *ngFor="let answer of question.answers">
          <mat-radio-button  [value]="answer" [checked]="answer.selected" (change)="saveSelection(question, answer)"/>
        </div>
      </mat-radio-group>
    </div>
    <mat-divider></mat-divider>
  </ng-container>
</div>